// import {
//   StyleSheet,
//   Text,
//   View,
//   ScrollView,
//   SafeAreaView,
//   Dimensions,
//   useWindowDimensions
// } from "react-native";
// import { vw, vh, vmin, vmax } from "react-native-expo-viewport-units";
// import Home from "./src/Home";
// import About from "./src/About";
// import Experience from "./src/Experience";
// import Nav from "./src/Nav";
// import Education from "./src/Education";
// import Portfolio from "./src/Portfolio";
// import Contact from "./src/Contact";
// import Footer from "./src/Footer";
// import { useState } from "react";
// // const window= useWindowDimensions()
// export default function App() {
//   const [page, setPage] = useState("Home");

//   return (
//     <View style={styles.container}>
//       <ScrollView>
//         <Nav setPage={setPage} />
//         {page === "Home" && <Home />}
//         {page === "Experience" && <Experience />}
//         {page === "Portfolio" && <Portfolio />}
//         {page === "Education" && <Education />}
//         {page === "Contact" && <Contact />}
//         {page === "About" && <About />}
//         <Footer />
//       </ScrollView>
//     </View>
//   );
// }

// const styles = StyleSheet.create({
//   container: {
//     flex: 1,
//   backgroundColor:"#fff",
  
  
    
//   },
// });
import * as React from 'react';
import { NavigationContainer, DefaultTheme} from '@react-navigation/native';
import MyDrawer from './assets/Components/MyDrawer';
import Footer from "./src/Footer";

const MyTheme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    primary: 'rgb(255, 45, 85)',
  },
};
export default function App() {
  return (
    <>
      <NavigationContainer theme={MyTheme}>
        <MyDrawer  MyDrawer={MyDrawer}/>
      </NavigationContainer>
      <Footer />
    </>
  );
}




// import React, { useState } from "react";
// import {Button, Text, StyleSheet, View} from 'react-native';
// import FadeInOut from 'react-native-fade-in-out';

// const App = () => {
//   const [visible, setVisible] = useState(true);

//   const toggleVisible = () => {
//     setVisible(!visible);
//   }

//   return (
//     <View style={styles.container}>
     
      
//       <FadeInOut visible={visible} rotate={true}>
//         <Text>Rotate</Text>
//       </FadeInOut>
//       <Button onPress={toggleVisible} title="Start Fade" />
//       <Button onPress={toggleVisible} title="Start Fade" />
//     </View>
//   );
// }

// const styles = StyleSheet.create({
//   container: {
//     flex: 1,
//     alignItems: 'center',
//     justifyContent: 'space-evenly',
//   },
// });

// export default App;
